<h1 mat-dialog-title>Invite a medical professional</h1>

<div mat-dialog-content>
    <!-- One path (owner, 2026-09-22): the server decides what the address becomes, and never says which. -->
    <p class="hint">Enter their email address. If they already use MedicAI, their practice owner is asked to link your
        practices; otherwise we email them an invitation to MedicAI Referrals<ng-container *ngIf="data?.practiceLinksEnabled">,
        with your practice's referral code for MedicAI subscribers</ng-container>. Nothing about your patients is shared
        until they accept and you refer a patient to them.</p>

    <form [formGroup]="form" (ngSubmit)="submit()" class="rid-form">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email address</mat-label>
            <input matInput type="email" formControlName="email" autocomplete="off" data-test="invite-email" required>
            <mat-error *ngIf="emailInvalid">Enter a valid email address.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Name (optional)</mat-label>
            <input matInput formControlName="name" maxlength="200" data-test="invite-name">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>HPCSA number (optional)</mat-label>
            <input matInput formControlName="hpcsaNumber" maxlength="20" data-test="invite-hpcsa">
        </mat-form-field>
    </form>

    <div class="rid-error" *ngIf="error" data-test="invite-error">
        <mat-icon>error_outline</mat-icon>
        <div>{{ error }}</div>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="isSaving">Cancel</button>
    <button mat-flat-button color="primary" (click)="submit()" [disabled]="!canSubmit" data-test="invite-submit">
        {{ isSaving ? 'Sending…' : 'Send invitation' }}
    </button>
</div>
